// eslint-disable-next-line no-unused-vars
import React, { useEffect, useState } from 'react';
import error from '../assets/images/wrencher-min.png';
import logo from '../assets/images/araglogo3@2x.png';
const getOnlineStatus = () => {
    return typeof navigator !== 'undefined' &&
        typeof navigator.onLine === 'boolean'
        ? navigator.onLine
        : true;
};
const useOnlineStatus = () => {
    let [onlineStatus, setOnlineStatus] = useState(getOnlineStatus());
    let [offlineImage, setOfflineImage] = useState({
        error: error,
        logo: logo,
    });

    function goOnline() {
        setOnlineStatus(true);
    }
    function goOffline() {
        setOnlineStatus(false);
    }
    useEffect(() => {
        setOfflineImage({ error: error, logo: logo });
        window.addEventListener('online', goOnline);
        window.addEventListener('offline', goOffline);
        return () => {
            window.removeEventListener('online', goOnline);
            window.removeEventListener('offline', goOffline);
        };
    }, []);

    return {
        onlineStatus: onlineStatus,
        offlineImage: offlineImage,
    };
};

export default useOnlineStatus;
